export default {
  readItem(state, item) {
    setTimeout(() => state.commit('itemIsRead', { item }), 500);
  },
};



// WEBPACK FOOTER //
// ./src/modules/messages/store/actions.js